import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/SkipNext.svg'

export const IconSkipNext = IconSVG as IconComponent
